import React, { useState } from "react";
import { UserActivityContext as Context } from "./index";
import { getUserActivityApi } from "../Api/GetUserActivity.js";
import { alertToastErrorFromResponse } from "../../../Shared/Utils/errorUtils.js";
import { errorGettingData } from "../../../Shared/Constants/index.jsx";

const UserActivityProvider = (props) => {
  const [tableData, setTableData] = useState([]);
  const [apiErrors, setApiErrors] = useState([]);
  const [item, setItem] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [filters, setFilters] = useState({});

  const modalTogle = () => {
    setModal(!modal);
  };

  //get all item data
  const getItem = async (id) => {
    setLoading(true);
    try {
      let response = await getUserActivityApi(id);
      if (response.result === "success") {
        let data = response.data;
        setItem(data);
      } else {
        setItem({});
        alertToastErrorFromResponse(errorGettingData, response);
      }
    } catch (error) {
      alertToastErrorFromResponse(errorGettingData, error);
    } finally {
      setLoading(false);
    }
  };

  //List objects frokm db
  const fetchTableData = async (page, limit) => {
    setLoading(true);
    try {
      let response = await getUserActivityApi({
        page: page,
        limit: limit,
        ...filters,
      });
      let data = response.data;

      if (response.result === "success") {
        setTableData(data.items); // Append new data
        setTotalRows(data.totalRows); // Append new data
      } else {
        setTableData([]); // Append new data
        setTotalRows(0); // Append new data
        alertToastErrorFromResponse(errorGettingData, response);
      }
    } catch (error) {
      alertToastErrorFromResponse(errorGettingData, error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Context.Provider
      value={{
        ...props,
        tableData,
        fetchTableData,
        setCurrentPage,
        setRowsPerPage,
        setLoading,
        apiErrors,
        modalTogle,
        modal,
        item,
        loading,
        currentPage,
        totalRows,
        rowsPerPage,
        getItem,
        setItem,

        filters,
        setFilters,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};
export default UserActivityProvider;
